class Response {
  constructor(data, component) {
    this.data = data
    this.component = component
  }

  addText() {
    if (!this.data.text) return this

    this.component.clearComposer('message')

    this.component.mutableMessage = this.data.text
    this.component.mutableContainer = this.data.text

    return this
  }

  addName() {
    if (!this.data.name) return this

    this.component.$message.info(
      `Editor actualizado con respuesta ${this.data.name}`
    )

    return this
  }

  addImage() {
    if (!this.data.image) return this

    this.component.clearComposer('files')
    this.component.$emit('imagePush', { type: 'image', src: this.data.image })

    return this
  }

  addFile() {
    if (!this.data.file) return this

    this.component.$emit('filePush', { type: 'file', src: this.data.file })
  }
}

module.exports = { Response }
